import VueI18n from 'vue-i18n';
import Dutch from '@/language/Dutch';
import English from '@/language/English';
import Language from '@/language/Language';
import LanguageCode, { languageCodes } from '@/language/LanguageCode';

export default class LanguageFactory {
    public createFrom(i18n: VueI18n): Language {
        const languageCode = i18n.locale as LanguageCode;

        if (!languageCodes.includes(languageCode)) {
            return this.default();
        }

        return this.create(languageCode);
    }

    public create(code: LanguageCode): Language {
        switch (code) {
            case LanguageCode.NL:
                return new Dutch();
            case LanguageCode.EN:
                return new English();
        }
    }

    public default(): Language {
        return this.create(LanguageCode.NL);
    }

    public fallback(): Language {
        return this.create(LanguageCode.EN);
    }

    public list(): Array<Language> {
        return languageCodes.map(code => this.create(code));
    }
}
